import ProfileLanguagesSection from './ProfileLanguagesSection.component';

export default ProfileLanguagesSection;